<template>
  <span :title="title">{{shortText}}</span>
</template>

<script>
  export default {
    name: "athub-short-text",
    props: {
      text: {
        type: String,
        default: ''
      },
      showMaxLength: {
        type: Number,
        default: 10
      }
    },
    data() {
      return {
      };
    },
    computed: {
      shortText() {
        let shortText;
        if (this.text == null) {
          shortText = '';
        } else {
          shortText = this.text.length > this.showMaxLength ? (this.text.substring(0, this.showMaxLength - 6) + '......') : this.text;
        }
        return shortText;
      },
      title() {
        let title;
        if (this.text == null) {
          title = '';
        } else {
          // 英文引号会导致html不合法
          title = this.text.replace(/"([^"]*)"/g, '“$1”');
        }
        return title;
      }
    }
  }
</script>

<style scoped>

</style>